module.exports = __webpack_public_path__ + "static/media/node-js.6b8cf607.svg";